import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import SaleTypeModel from "../../models/masters/saletype-model";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/SaleType/GetAllSaleType";// //{/api/SaleType/GetAllSaleType}`)  //// "https://localhost:7054/api/SaleType/GetAllSaleType";
export const useGetSaleTypes = createQuery<
  SaleTypeModel[],
  null,
  AxiosError
>({
  queryKey: ["keySaleTypelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});